import businessGroupsApi from '../services/api'

export default {
  namespaced: true,
  actions: {
    getBusinessGroups: async function ({ commit }, payload) {
      return await businessGroupsApi.getItems(payload).then(response => response.data)
    },
  },
}
